var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_play_billing)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 48,
    height: 48,
    rx: 16,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 3.5,
    width: 47,
    height: 47,
    rx: 15.5,
    stroke: "#F3F4F6",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17, 15) scale(1.05)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.67 12.24 3.14 22.68A2.41 2.41 0 0 0 5.53 22.8L18.05 15.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M20.76 10.58 18.05 9 12.67 12.24 18.05 15.6l2.71-1.57a2.42 2.42 0 0 0 0-3.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M3.14 1.32 12.67 11.76 18.05 9 5.53 1.2A2.4 2.4 0 0 0 3.14 1.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M3.14 1.32A2.48 2.48 0 0 0 2.8 2.77V21.23a2.48 2.48 0 0 0 .34 1.45L12.67 12.24Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_play_billing",
    x: 0,
    y: 0,
    width: 58,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_play_billing"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0901961 0 0 0 0 0.101961 0 0 0 0 0.121569 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_play_billing",
    result: "effect2_dropShadow_play_billing"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_play_billing",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBilling);
export default __webpack_public_path__ + "static/media/google_play_billing.6a4faedaa1bec1fca8042efd4805cd20.svg";
export { ForwardRef as ReactComponent };